import { Grid } from "@mui/material";
import { styled } from "@mui/system";


export const DetailItem = styled(Grid)(() => ({
  gap: "4px",
  display: "flex",
  flexDirection: "column"
}))